module.exports = __webpack_public_path__ + "img/parquimetro.abcebb6f.png";